export default __webpack_public_path__ + "static/media/card-w-product.00f7c045.png";